"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrcSystem = exports.LosgType = exports.DataGroupIdType = exports.ProductSubType = exports.ProductGroupType = exports.ItemType = exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["ADD"] = "ADD";
    ActionType["MODIFY"] = "MODIFY";
    ActionType["NO_CHANGE"] = "NO_CHANGE";
    ActionType["REMOVE"] = "REMOVE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ItemType;
(function (ItemType) {
    ItemType["DEVICE"] = "DEVICE";
    ItemType["FEATURE"] = "FEATURE";
    ItemType["SHARED_DATA_GROUP"] = "sharedDataGroup";
    ItemType["SHARED_DATA_FEATURE"] = "SHAREDDATAFEATURE";
    ItemType["VOICEPLAN"] = "VOICEPLAN";
    ItemType["EQUIPMENT"] = "EQUIPMENT";
    ItemType["ACCESSORY"] = "ACCESSORY";
    ItemType["HARD_GOOD_TRADE_IN"] = "hardgoodtradein";
    ItemType["LOSG"] = "LOSG";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var ProductGroupType;
(function (ProductGroupType) {
    ProductGroupType["WIRELESS"] = "WIRELESS";
    ProductGroupType["DTVNOW"] = "DTVNOW";
})(ProductGroupType = exports.ProductGroupType || (exports.ProductGroupType = {}));
var ProductSubType;
(function (ProductSubType) {
    ProductSubType["INSURANCE"] = "INSURANCE";
})(ProductSubType = exports.ProductSubType || (exports.ProductSubType = {}));
var DataGroupIdType;
(function (DataGroupIdType) {
    DataGroupIdType["EXISTING_DG_ID"] = "EXISTING_DGID";
})(DataGroupIdType = exports.DataGroupIdType || (exports.DataGroupIdType = {}));
var LosgType;
(function (LosgType) {
    LosgType["NEW"] = "NEW";
})(LosgType = exports.LosgType || (exports.LosgType = {}));
var SrcSystem;
(function (SrcSystem) {
    SrcSystem["IDSE"] = "IDSE";
})(SrcSystem = exports.SrcSystem || (exports.SrcSystem = {}));
//# sourceMappingURL=CartActions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/models/requests/CartActions.js
// module id = 198
// module chunks = 8